/**
 * Vemorina cart-add — AJAX add-to-cart for bundle-nudge buttons.
 *
 * Listens for clicks on `[data-vm-cart-add="{variant_id}"]` buttons,
 * POSTs to /cart/add.js, then dispatches Symmetry's `on:cart:change`
 * event so its <cart-form> custom element auto-refreshes the drawer
 * via Section Rendering API + mergeNodes.
 *
 * No full page reload. No setTimeout polling. Smooth.
 *
 * Author: shopify-builder, 2026-05-16
 */
(function () {
  'use strict';

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-vm-cart-add]');
    if (!btn) return;
    if (btn.disabled) return;
    e.preventDefault();

    const variantId = btn.dataset.vmCartAdd;
    if (!variantId) return;

    // Mark as loading
    btn.disabled = true;
    btn.classList.add('is-loading');
    const originalText = btn.textContent;
    btn.textContent = 'Adding…';

    try {
      // Locale/market-aware cart endpoint. window.Shopify.routes.root always
      // ends in "/" and carries the active market prefix (e.g. "/nl/"), so the
      // add preserves the visitor's language and currency context. Falls back
      // to "/" if the global is unavailable.
      // Docs: https://shopify.dev/docs/storefronts/themes/markets/multiple-currencies-languages
      const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!response.ok) {
        const errorText = await response.text();
        // Shopify returns JSON errors with `description` field
        let errorMsg = 'Could not add';
        try {
          const errorJson = JSON.parse(errorText);
          if (errorJson.description) errorMsg = errorJson.description;
        } catch (e) { /* not JSON */ }
        throw new Error(errorMsg);
      }

      // Dispatch Symmetry's cart-change event — <cart-form> listens to this
      // and triggers refresh() via Section Rendering API + mergeNodes.
      document.dispatchEvent(
        new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
      );

      // Also dispatch on:cart:add for any specific listeners (analytics, etc.)
      document.dispatchEvent(
        new CustomEvent('on:cart:add', { bubbles: true, cancelable: false })
      );

      // After Symmetry's mergeNodes runs (~300ms later), the nudge button
      // will either be replaced by a new nudge state OR removed entirely
      // (if 3+ items now in cart). We don't need to manually restore.
    } catch (err) {
      console.error('[vm-cart-add] Add failed:', err);
      btn.textContent = 'Try again';
      // Restore the button after 2 seconds so the user can retry
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
        btn.classList.remove('is-loading');
      }, 2000);
    }
  });
})();
